import { useState, useEffect, useLayoutEffect, useCallback } from "react";
import useResponsive from "libs/helpers/useResponsive";

export default function useDropdownPlacement(
  triggerRef,
  isOpen,
  {
    dropdownRef,
    forceBottom = false,
    gap = 8,
    mobileBottomOffset = 103 + 8,
  } = {},
) {
  const [openTop, setOpenTop] = useState(false);
  const { max } = useResponsive();

  const updatePlacement = useCallback(() => {
    if (!forceBottom && triggerRef?.current && dropdownRef?.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.getBoundingClientRect().height;
      const bottomOffset = max.sm ? mobileBottomOffset : 0;
      const space_below = window.innerHeight - rect.bottom - bottomOffset - gap;
      const space_above = rect.top - gap;

      setOpenTop(space_below < dropdownHeight && space_above > space_below);
    } else {
      setOpenTop(false);
    }
  }, [triggerRef, dropdownRef, forceBottom, gap, max.sm, mobileBottomOffset]);

  useLayoutEffect(() => {
    if (!isOpen) return setOpenTop(false);

    updatePlacement();

    if (typeof ResizeObserver === "undefined") return;

    const observer = new ResizeObserver(updatePlacement);

    if (triggerRef?.current) observer.observe(triggerRef.current);
    if (dropdownRef?.current) observer.observe(dropdownRef.current);

    return () => observer.disconnect();
  }, [isOpen, updatePlacement, triggerRef, dropdownRef]);

  useEffect(() => {
    if (!isOpen) return;

    window.addEventListener("scroll", updatePlacement, true);
    window.addEventListener("resize", updatePlacement);

    return () => {
      window.removeEventListener("scroll", updatePlacement, true);
      window.removeEventListener("resize", updatePlacement);
    };
  }, [isOpen, updatePlacement]);

  return openTop;
}
